var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54688 2.84766L11.0421 4.94477C11.4443 5.18613 11.7694 5.5372 11.9792 5.95679L12.2198 6.43795C12.391 6.78046 12.4802 7.15813 12.4802 7.54107V9.01432",
    stroke: "#323232",
    strokeWidth: 0.924615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13477 12.4241V15.1803C7.13477 16.5426 8.23913 17.647 9.60143 17.647H16.5903C17.9526 17.647 19.057 16.5426 19.057 15.1803V11.4803C19.057 10.118 17.9526 9.01367 16.5903 9.01367H8.3681",
    stroke: "#323232",
    strokeWidth: 0.924615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37079 7.78105V9.42549L10.1712 11.2266C10.663 11.7186 10.7016 12.5034 10.2605 13.0413C9.81935 13.5792 9.04224 13.695 8.46345 13.3091L4.77332 10.8483C4.18836 10.4582 3.7438 9.89093 3.50488 9.22967L2.61523 6.76758",
    stroke: "#323232",
    strokeWidth: 0.924615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5215 11.8396L12.5495 13.0243C12.897 13.2273 13.3269 13.2273 13.6744 13.0243L18.6475 10.1191",
    stroke: "#323232",
    strokeWidth: 0.924615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.f520f1fe4d1b1199f076ff80ee971264.svg";
export { ForwardRef as ReactComponent };